




// @ is an alias to /src
import {Component, Mixins} from "vue-property-decorator";
import PropertyBulkEdit from "@/components/property/propertyBulkEdit.vue";
import PropertyBulkEditLimit from "@/components/property/propertyBulkEditLimit.vue";
import Authority from "@/common/mixins/authority";

@Component({
  name: "PropertyBulkEditPage",
  components: {
    PropertyBulkEdit,
    PropertyBulkEditLimit,
  },
})
export default class PropertyBulkEditPage extends Mixins(Authority) {
  get componentEdit() {
    return this.$ability.can("bulk-edit-fully", "Property")
      ? "PropertyBulkEdit"
      : "PropertyBulkEditLimit";
  }
}
